/* eslint-disable */
import React, { useState, useEffect, useContext, useRef } from 'react';
import Xarrow, { useXarrow, Xwrapper } from 'react-xarrows';
import Draggable from 'react-draggable';
import { Button, Modal, Form, Row, Col, Table } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { AiFillSetting } from "react-icons/ai";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import categoriesApi from "../../../api/categoriesApi";
import BlockApi from "../../../api/blockApi";
import ConnectionApi from "../../../api/connectionApi";
import reportApi from "../../../api/reportApi";
import projectApi from "../../../api/projectApi";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DeleteModel from "../../../components/DeleteModel";
import { CCollapse } from '@coreui/react';
import CreateProjectModel from "../../../components/CreateProjectModel";
import ProjectContext from '../../../context/projectContext';
import "../../../assets/css/tempStyle.css"

const blockStyle = {
    width: "50px",
    alignitems: "center",
    width: "fit-content",
    minWidth: "70px",
    maxWidth: "75px",
    padding: "0px 5px 5px 5px",
    display: "inline-block",
    position: 'fixed',
    zIndex: 999,
    cursor: "pointer"
}

const PDAModel = () => {
    const { projectId, updateProject } = useContext(ProjectContext);
    const { projectDetails, updateProjectDetails } = useContext(ProjectContext);
    const [showSettingsPopup, setShowSettingsPopup] = useState(false);
    const [showBlockPopup, setShowBlockPopup] = useState(false);
    const [showReportPopup, setShowReportPopup] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [validated, setValidated] = useState(false);
    const [categoriesList, setCategoriesList] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [connections, setConnections] = useState([]);
    const [activeRow, setActiveRow] = useState(""); // blockID
    const [runPDAMsg, setrunPDAMsg] = useState();
    const [visible, setVisible] = useState(true)
    const [panning, setPanning] = useState(false);

    const [showProjectModal, setShowProjectModal] = useState(false);
    const [showDeleteProjectModal, setShowDeleteProjectModal] = useState(false);

    const [blockNumber, setBlockNumber] = useState(0);
    const [blockColor, setBlockColor] = useState("");
    const [recentFourColors, setRecentFourColors] = useState([]);
    const [selectedBlocks, setSelectedBlocks] = useState([]);
    const [selectedBlocksP, setSelectedBlocksP] = useState({ x: 0, y: 0 });
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [blockNumberError, setBlockNumberError] = useState('');

    // =========================== scroll ========================

    let [isFirstFocus, setIsFirstFocus] = useState(false);
    let [isDraggingbox, setIsDraggingbox] = useState(false);
    let [isDragging, setIsDragging] = useState(false);
    let [initialMousePosition, setInitialMousePosition] = useState({ x: 0, y: 0 });
    let [initialGroupPosition, setInitialGroupPosition] = useState({ x: 0, y: 0 });
    let [initialSelectedGroupPosition, setInitialSelectedGroupPosition] = useState({ x: 0, y: 0 });
    let [layer1Size, setLayer1Size] = useState({ width: 4000, height: 4000 });
    const [groupPosition, setGroupPosition] = useState({ x: 0, y: 0 });
    let [isGroupDraggingActive, setIsGroupDraggingActive] = useState(false);
    const scrollSensitivity = 0.04; // Adjust this value as needed
    const [isMouseBetweenPosition, setIsMouseBetweenPosition] = useState(false);
    const [arrowSizing, setArrowSizing] = useState({
        strokeWidth: 4,
        headSize: 5,
        scale: 0.5
    })

    const [boxXYPosition, setBoxXYPosition] = useState({
        topLeft: { x: 0, y: 0 },
        topRight: { x: 0, y: 0 },
        bottomLeft: { x: 0, y: 0 },
        bottomRight: { x: 0, y: 0 }
    });

    const [SelectedboxXYPosition, setSelectedBoxXYPosition] = useState({
        topLeft: { x: 0, y: 0 },
        topRight: { x: 0, y: 0 },
        bottomLeft: { x: 0, y: 0 },
        bottomRight: { x: 0, y: 0 }
    });

    const findXYposition = (boxes) => {
        const boxWidth = 75;
        const boxHeight = 100;

        let topLeftX = Infinity;
        let topLeftY = Infinity;
        let bottomRightX = -Infinity;
        let bottomRightY = -Infinity;

        boxes.forEach(box => {
            const { positionX, positionY } = box;

            // Calculate corners for each box
            const boxRightX = positionX + boxWidth;
            const boxBottomY = positionY + boxHeight;

            // Update topLeftX and topLeftY
            topLeftX = Math.min(topLeftX, positionX);
            topLeftY = Math.min(topLeftY, positionY);

            // Update bottomRightX and bottomRightY
            bottomRightX = Math.max(bottomRightX, boxRightX);
            bottomRightY = Math.max(bottomRightY, boxBottomY);
        });
        setBoxXYPosition({
            topLeft: { x: topLeftX, y: topLeftY },
            topRight: { x: bottomRightX, y: topLeftY },
            bottomLeft: { x: topLeftX, y: bottomRightY },
            bottomRight: { x: bottomRightX, y: bottomRightY }
        });
    }

    const findClickIsBetweenPosition = (clientX, clientY, ctrTrue = false) => {

        let topLeft = { x: 0, y: 0 }
        let bottomRight = { x: 0, y: 0 }

        if (ctrTrue) {
            topLeft = { x: SelectedboxXYPosition.topLeft.x, y: SelectedboxXYPosition.topLeft.y };
            bottomRight = { x: SelectedboxXYPosition.bottomRight.x, y: SelectedboxXYPosition.bottomRight.y };
        } else {
            topLeft = { x: boxXYPosition.topLeft.x, y: boxXYPosition.topLeft.y };
            bottomRight = { x: boxXYPosition.bottomRight.x, y: boxXYPosition.bottomRight.y };
        }

        const layer1 = document.getElementById('zoom-container');
        const layer1Rect = layer1.getBoundingClientRect();
        const relativeX = (clientX - layer1Rect.left) / scale;
        const relativeY = (clientY - layer1Rect.top) / scale;
        if (
            relativeX >= topLeft.x &&
            relativeX <= bottomRight.x &&
            relativeY >= topLeft.y &&
            relativeY <= bottomRight.y
        ) {
            if (!isGroupDraggingActive) {

                if (ctrTrue) {
                    setInitialSelectedGroupPosition({ x: relativeX, y: relativeY });
                } else {
                    setInitialGroupPosition({ x: relativeX, y: relativeY });
                }


                setIsGroupDraggingActive(true)
            }
        }
    }

    const checkCurserEnteredBetweenPosition = (clientX, clientY) => {
        const topLeft = { x: boxXYPosition.topLeft.x, y: boxXYPosition.topLeft.y };
        const bottomRight = { x: boxXYPosition.bottomRight.x, y: boxXYPosition.bottomRight.y };
        const layer1 = document.getElementById('zoom-container');
        const layer1Rect = layer1.getBoundingClientRect();
        const relativeX = (clientX - layer1Rect.left) / scale;
        const relativeY = (clientY - layer1Rect.top) / scale;
        if (
            relativeX >= topLeft.x &&
            relativeX <= bottomRight.x &&
            relativeY >= topLeft.y &&
            relativeY <= bottomRight.y
        ) {
            setIsMouseBetweenPosition(true)

        } else {
            setIsMouseBetweenPosition(false)
        }
    }

    // =========================== scroll ========================

    const handleClose = () => setShowDeletePopup(false);
    const navigate = useNavigate()

    const updateXarraow = useXarrow();
    const scrollFunc = () => {
        updateXarraow();
    };

    const handleHoverElementMouseEnter = () => {
        setPanning(true);
    };

    const handleHoverElementMouseLeave = () => {
        setPanning(false);
    };

    const [scale, setScale] = useState(2);
    const minScale = 1.4;
    const maxScale = 2;
    const wheelTimeout = useRef()

    const handleZoomIn = () => {
        const newScale = Math.round((scale + 0.1) * 10) / 10;
        if (newScale <= maxScale) {
            adjustArrowsize(newScale)
            setScale(newScale);
        }
    };

    const handleZoomOut = () => {
        const newScale = Math.round((scale - 0.1) * 10) / 10;
        if (newScale >= minScale) {
            adjustArrowsize(newScale)
            setScale(newScale);
        }
    };

    const adjustArrowsize = (scale) => {
        let d = { ...arrowSizing };
        switch (scale) {
            case 1.4:
                d.scale = 0.71;
                break;
            case 1.5:
                d.scale = 0.658;
                break;
            case 1.6:
                d.scale = 0.624;
                break;
            case 1.7:
                d.scale = 0.59;
                break;
            case 1.8:
                d.scale = 0.56;
                break;
            case 1.9:
                d.scale = 0.53;
                break;
            case 2:
                d.scale = 0.5;
                break;
        }
        setArrowSizing(d);
    }

    useEffect(() => {
        const cancelWheel = e => wheelTimeout.current && e.preventDefault()
        document.body.addEventListener('wheel', cancelWheel, { passive: false })
        return () => document.body.removeEventListener('wheel', cancelWheel)
    }, [])

    const handleClickOutside = (event) => {
        if (!event.target.closest('.handle') && !event.target.closest('.btn')) {
            setConnectionData({
                ...connectionData,
                start: null
            });
            setActiveRow("");
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleOnStopPosition = async (dragElement, ui, items) => {

        // set selected block
        let id = items.blockId
        let CategoryName = categoriesList && categoriesList.find(item => item.categoryId === items.categoryId)
        let blockData = {
            projectId: projectId,
            blockId: items.blockId,
            blockNumber: items.blockNumber,
            blockColor: items.blockColor,
            blockName: items.blockName,
            categoryId: items.categoryId,
            duration: items.duration,
            p10: items.p10,
            p90: items.p90,
            a: items.a,
            b: items.b,
            upperBound: items.upperBound,
            lowerBound: items.lowerBound,
            positionX: Math.round(ui.x),
            positionY: Math.round(ui.y),
            CategoryName: CategoryName.category1
        }
        let b = [...blocks];
        b.map((e, index) => {
            if (e.blockId == id) {
                b[index] = blockData;
            }
        });
        setBlocks(b);
        const Api = new BlockApi();
        await Api.editBlock(id, blockData);
        getBlocks(categoriesList);
        updateXarraow();
    };

    const [settingsData, setSettingsData] = useState({
        id: "",
        numberOfRuns: "",
        alpha: "",
        beta: "",
        lowerBoundMultiplier: "",
        upperBoundMultiplier: ""
    });

    const clearSettingsData = () => {
        let d = { ...settingsData }
        d.numberOfRuns = ""
        d.alpha = ""
        d.beta = ""
        d.lowerBoundMultiplier = ""
        d.upperBoundMultiplier = ""
        setBlockData(d)
    };

    const [blockData, setBlockData] = useState({
        blockId: "",
        blockNumber: blockNumber,
        blockColor: blockColor,
        blockName: "",
        categoryId: "",
        duration: "",
        p10: "",
        p90: "",
        positionX: "",
        positionY: "",
        a: "",
        b: "",
        lowerBound: "",
        upperBound: ""
    });

    const clearBlockData = () => {
        let d = { ...blockData }
        d.blockId = ""
        d.blockNumber = blockNumber
        d.blockColor = blockColor
        d.blockName = ""
        d.categoryId = ""
        d.duration = ""
        d.p10 = ""
        d.p90 = ""
        d.positionX = ""
        d.positionY = ""
        d.a = "";
        d.b = "";
        d.lowerBound = "";
        d.upperBound = "";
        setBlockData(d)
        setBlockColor("#dfe5eb")
    };

    const [connectionData, setConnectionData] = useState({
        id: null,
        start: null,
        end: null
    });

    const clearConnectionData = () => {
        let d = { ...connectionData }
        d.id = null
        d.start = null
        d.end = null
        setConnectionData(d)
    };

    useEffect(() => {
        if (projectId) { // Check if projectId is present
            getCategoriesList();
            getSettings();
            getProjectDetails();

            // Clear block details when projectId changes
            setBlockNumber(0);
            setBlockColor("");
            setRecentFourColors([]);
        }
    }, [projectId]);

    useEffect(() => {
        if (projectId && connectionData.start !== null && connectionData.end !== null) { // Check if projectId is present
            addConnection();
        }
    }, [connectionData, projectId]);

    useEffect(() => {
        if (projectId) { // Check if projectId is present
            handleHoverElementMouseEnter();
            updateXarraow();
            getConnections();
            handleHoverElementMouseLeave();
        }
    }, [scale, projectId]);


    const getProjectDetails = async () => {
        const Api = new projectApi();
        if (projectId !== null && projectId !== "") {
            let result = await Api.getProjectDetails(projectId);
            if (result) {
                setProjectData(result);
                updateProjectDetails(result);
            }
        }
    };

    const getCategoriesList = async () => {
        const Api = new categoriesApi();
        await Api.getAllCategories(projectId).then(async (response) => {
            setBlocks([])
            setConnections([])
            setIsFirstFocus(false)
            if (response && response.length) {
                setCategoriesList(response)
                getBlocks(response);
            } else {
                setCategoriesList([])
                setBlocks([])
                setConnections([])
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    }

    const getSettings = async () => {
        const Api = new BlockApi();
        await Api.getSettings(projectId).then(async (response) => {
            if (response) {
                setSettingsData(response)
            } else {
                setSettingsData({})
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    }

    const handleSettingsChange = (e) => {
        let { name, value } = e.target;
        setSettingsData({
            ...settingsData,
            [name]: value
        });
    };

    const saveSettings = async (e) => {
        e.preventDefault()
        const Api = new BlockApi();
        await Api.saveSettings(settingsData, projectId).then(async (response) => {
            if (response) {
                setSettingsData(response);
                toast.success("Configuration saved successfully.")
                setShowSettingsPopup(false);
                clearSettingsData();
            } else {
                toast.error("Something went wrong.")
            }
        })
    };

    const getBlocks = async (categoryData) => {
        const Api = new BlockApi();
        await Api.getAllBlocks(projectId).then(async (response) => {
            if (response && response.length) {
                if (categoryData && categoryData.length) {
                    response.map(item1 => {
                        let CategoryName = categoryData && categoryData.find(item2 => item2.categoryId === item1.categoryId)
                        item1['CategoryName'] = CategoryName ? CategoryName.category1 : ""
                    })
                }
                setBlocks(response);
                // save Y X position for detect click
                findXYposition(response);
                getConnections();

                const maxNumber = Math.max(...response.map(block => block.blockNumber), 0);
                setBlockNumber(maxNumber + 1);

                const lastBlock = response[response.length - 1];
                setBlockColor(lastBlock.blockColor);

                const colors = [...new Set(response.map(block => block.blockColor === "" ? "#dfe5eb" : block.blockColor))].slice(-4);
                setRecentFourColors(colors);
            } else {
                setBlocks([])
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    }

    const handleBlockChange = (e) => {
        let { name, value } = e.target;
    
        let updatedData = {
            ...blockData,
            [name]: value
        };
    
        if (name === "blockNumber") {
            const parsedValue = parseFloat(value);
            const isDuplicate = blocks.some((b) => {
                const sameNumber = parseFloat(b.blockNumber) === parsedValue;
                return blockData.blockId === "" ? sameNumber : sameNumber && b.blockId !== blockData.blockId;
            });
    
            if (isDuplicate) {
                setBlockNumberError("Block number already exists.");
            } else {
                setBlockNumberError("");
            }
        }
    
        if (name === "categoryId") {
            let foundColor = categoriesList.find(item => item.categoryId == value);
            updatedData.blockColor = foundColor?.categoryColor || "";
            setBlockColor(foundColor?.categoryColor || "");
        }
    
        setBlockData(updatedData);
    };    

    const checkCategories = async () => {
        const Api = new categoriesApi();
        await Api.getAllCategories(projectId).then(async (response) => {
            if (response && response.length == 0) {
                toast.error("Please add category before creating the new block.")
            }
        });
    };

    const addBlock = async (e) => {
        const form = e.currentTarget;
        setIsFirstFocus(true);
        e.preventDefault();

        const duplicate = blocks.some(
            (block) =>
                block.blockNumber === Number(blockData.blockNumber) &&
                block.blockId !== blockData.blockId
        );

        if (duplicate) {
            setBlockNumberError("Block number already exists.");
            setValidated(true);
            return;
        } else {
            setBlockNumberError("");
        }

        if (!isButtonDisabled && form.checkValidity()) {
            setIsButtonDisabled(true);
            const Api = new BlockApi();

            const updatedBlockData = { ...blockData };
            updatedBlockData.a = updatedBlockData.a || 0;
            updatedBlockData.b = updatedBlockData.b || 0;
            updatedBlockData.lowerBound = updatedBlockData.lowerBound || 0;
            updatedBlockData.upperBound = updatedBlockData.upperBound || 0;
            updatedBlockData.projectId = projectId;

            try {
                if (updatedBlockData.blockId) {
                    const response = await Api.editBlock(updatedBlockData.blockId, updatedBlockData);
                    console.log("response", response);
                    if (response.status === "error") {
                        toast.error(response.message);
                    } else {
                        getBlocks(categoriesList);
                        toast.success(response.message);
                    }
                } else {
                    delete updatedBlockData.blockId;
                    const newBlockPosition = calculateNewBlockPosition();
                    updatedBlockData.positionX = Math.round(newBlockPosition.x);
                    updatedBlockData.positionY = Math.round(newBlockPosition.y);

                    const response = await Api.addBlock(updatedBlockData);
                    if (!response.status) {
                        setActiveRow(response.blockId);
                        setConnectionData({
                            ...connectionData,
                            start: "block_" + response.blockId,
                        });
                        getBlocks(categoriesList);
                        setBlocks(oldArray => [...oldArray, response]);
                        toast.success("Added block successfully.");
                        clearBlockData();
                        setTimeout(() => {
                            const container = document.getElementById('hidden-div');
                            if (container) {
                                container.scrollLeft = newBlockPosition.x * scale - container.clientWidth / 2 + 75 / 2;
                                container.scrollTop = newBlockPosition.y * scale - container.clientHeight / 2 + 100 / 2;
                            }
                        }, 100);
                    } else {
                        toast.error(response.message);
                    }
                }
            } catch (error) {
                toast.error("An error occurred.");
            } finally {
                setShowBlockPopup(false);
                setValidated(false);
                setIsButtonDisabled(false);
            }
        } else {
            setValidated(true);
        }
    };

    const calculateNewBlockPosition = () => {
        const container = document.getElementById('hidden-div');
        if (!container) {
            return { x: 20, y: 20 };
        }
        const containerRect = container.getBoundingClientRect();
        const centerX = container.scrollLeft + container.clientWidth / 2;
        const centerY = container.scrollTop + container.clientHeight / 2;
        const scaledCenterX = centerX / scale;
        const scaledCenterY = centerY / scale;
        const blockWidth = 75;
        const blockHeight = 100;
        let newX = scaledCenterX - blockWidth / 2;
        let newY = scaledCenterY - blockHeight / 2;
        const step = 20;
        let overlap = true;
        while (overlap) {
            overlap = false;
            for (let block of blocks) {
                if (
                    newX < block.positionX + blockWidth &&
                    newX + blockWidth > block.positionX &&
                    newY < block.positionY + blockHeight &&
                    newY + blockHeight > block.positionY
                ) {
                    overlap = true;
                    newX += step;
                    newY += step;
                    if (newX + blockWidth > scaledCenterX * 2) {
                        newX = scaledCenterX - blockWidth / 2;
                        newY += step;
                    }
                    break;
                }
            }
        }

        return { x: newX, y: newY };
    };

    const getBlockDetails = async (blockId) => {
        const Api = new BlockApi();
        let result = await Api.getBlockDetails(blockId);
        if (result) {
            setBlockData(result)
        }
    };

    const handleShow = () => {
        setShowDeletePopup(true);
    }

    const deleteBlock = async () => {
        const Api = new BlockApi();
        await Api.deleteBlock(activeRow).then(async (response) => {
            if (response.status === "success") {
                setShowDeletePopup(false);
                getBlocks(categoriesList);
                setActiveRow("")
                clearConnectionData();
                toast.success("Deleted successfully.");
            } else {
                setShowDeletePopup(false);
                toast.error("Something went wrong.");
            }
        })
    };

    const clickBlock = (e, block_blockId, blockId) => {
        e.stopPropagation()
        if (connectionData.start && connectionData.start !== block_blockId) {
            if (e.target.classList.value == 'active') {
                setActiveRow("")
                setConnectionData({
                    ...connectionData,
                    start: null
                })
            } else {
                setActiveRow(blockId)
                setConnectionData({
                    ...connectionData,
                    end: block_blockId
                })
            }
            setActiveRow("")
        } else {
            if (connectionData.start && connectionData.start == block_blockId) {
                setConnectionData({
                    ...connectionData,
                    start: null
                })
                setActiveRow("")
            } else {
                setConnectionData({
                    ...connectionData,
                    start: block_blockId
                })
                setActiveRow(blockId)
            }
        }
    };

    const getConnections = async () => {
        const Api = new ConnectionApi();
        await Api.getAllConnections(projectId).then(async (response) => {
            if (response && response.length) {
                let data = response.map(item => {
                    let obj = {
                        id: item.id,
                        start: item.predecessorId,
                        end: item.blockId
                    }
                    return obj;
                })
                setConnections(data)
            } else {
                setConnections([])
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    }

    const addConnection = async () => {
        delete connectionData.id
        let modiData = {
            blockId: connectionData.end.split("_")[1],
            predecessorId: connectionData.start.split("_")[1]
        }
        const Api = new ConnectionApi();
        let result = await Api.addConnection(modiData);
        if (result === undefined) {
            toast.error("Already Connected.");
        } else {
            setConnections([...connections, { id: result.id, start: result.predecessorId, end: result.blockId }])
            clearConnectionData();
            getBlocks(categoriesList);
        }
    }

    const deleteConnection = async (id) => {
        const Api = new ConnectionApi();
        await Api.deleteConnection(id);
        getBlocks(categoriesList);
    };

    const runPDAModel = async () => {
        setrunPDAMsg("Generating Report ...");
        setShowReportPopup(true)
        const Api = new reportApi();
        await Api.runPDA(projectId).then((response) => {
            if (response.status === "success") {
                setShowReportPopup(false)
                navigate('/reports')
            } else {
                setrunPDAMsg(response.message.toString());
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    };

    const handleShowProjectModal = () => {
        setShowProjectModal(true);
    };

    const handleShowProjectDeleteModal = () => {
        setShowProjectModal(false)
        setShowDeleteProjectModal(true);
    }

    const handleCloseProjectModal = () => {
        setShowProjectModal(false);
        clearProjectData();
    };

    const handleCloseProjectDeleteModal = () => {
        setShowProjectModal(false);
        clearProjectData();
    };

    const [projectData, setProjectData] = useState({
        projectId: "",
        projectName: "",
        clientName: "",
        description: ""
    });

    const clearProjectData = () => {
        let d = { ...projectData }
        d.projectId = ""
        d.projectName = ""
        d.clientName = ""
        d.description = ""
        setProjectData(d)
    };

    const handleProjectChanges = (e) => {
        let { name, value } = e.target;
        setProjectData({
            ...projectData,
            [name]: value
        });
    };

    const checkDarkness = (color) => {
        if (!color) {
            return false;
        }
        let c = color.substring(1);
        let rgb = parseInt(c, 16);
        let r = (rgb >> 16) & 0xff;
        let g = (rgb >> 8) & 0xff;
        let b = (rgb >> 0) & 0xff;
        let darkness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        return darkness < 120;
    }

    const saveProjectData = async (e) => {
        e.preventDefault();
        if (!isButtonDisabled) {
            setIsButtonDisabled(true); // Disable button

            const Api = new projectApi();
            const response = await Api.getAllProjects();
            const projectNameExists = response.some(item => item.projectName === projectData.projectName);

            if (projectData.projectName === "") {
                toast.error("Project name is Required!");
                setIsButtonDisabled(false); // Re-enable button
            } else {
                if (projectNameExists) {
                    toast.error("Project name already exists!");
                    setIsButtonDisabled(false); // Re-enable button
                } else {
                    // Create project
                    delete projectData.projectId;
                    try {
                        const response = await Api.addProject(projectData);
                        if (response) {
                            if (projectId) {
                                getProjectDetails();
                            }
                            setProjectData(response);
                            updateProjectDetails(response);
                            updateProject(response.projectId);
                            sessionStorage.setItem("projectId", response.projectId);
                            toast.success("Project created successfully.");
                            setShowProjectModal(false);
                            clearProjectData();
                        } else {
                            toast.error("Something went wrong.");
                        }
                    } catch (error) {
                        toast.error("An error occurred.");
                    } finally {
                        setIsButtonDisabled(false); // Re-enable button
                    }
                }
            }
        }
    };

    const deleteProject = async () => {
        const Api = new projectApi();
        await Api.deleteProject(projectId).then(response => {
            if (response == undefined) {
                toast.error("Please clear the data before deleting the project.");
                setShowDeleteProjectModal(false)
            } else {
                setShowDeleteProjectModal(false)
                toast.success("Deleted successfully.");
                clearProjectData();
                updateProjectDetails(response)
                updateProject(null);
                sessionStorage.removeItem('projectId')
            }
        }).catch((error) => {
            setShowDeleteProjectModal(false);
            toast.success("Something went wrong.");
        });
    };

    const defaultPosition = () => {
        setScale(2)
        const keepInCheck = document.getElementById('hidden-div');
        const childDiv = document.getElementById('zoom-container');
        if (keepInCheck) {
            const rect = childDiv.getBoundingClientRect();
            let a = trakeMouseMoment({ clientX: 10 + rect.left, clientY: 10 + rect.top })
            const Api = new BlockApi();
            let totalmovedX = boxXYPosition.topLeft.x - a.x;
            let totalmovedY = boxXYPosition.topLeft.y - a.y;
            let list = [...blocks];
            list.map(e => {
                if (
                    Math.round(e.positionX - totalmovedX) >= 0 &&
                    Math.round(e.positionY - totalmovedY) >= 0
                ) {
                    e.positionX = Math.round(e.positionX - totalmovedX);
                    e.positionY = Math.round(e.positionY - totalmovedY);
                }
                Api.editBlock(e.blockId, e);
            });
            setBlocks(list);
            setGroupPosition({ x: 0, y: 0 })
            findXYposition(list);
            adjustArrowsize(2)
            keepInCheck.scrollTo(0, 0);
        }
    };

    const trakeMouseMoment = (event) => {
        const childDiv = document.getElementById('zoom-container');
        const rect = childDiv.getBoundingClientRect();
        const x = (event.clientX - rect.left) / scale;
        const y = (event.clientY - rect.top) / scale;
        return ({ x: x, y: y })
    }

    const handleGroupStopPosition = () => {
        const Api = new BlockApi();
        let totalmoved = { ...groupPosition }
        let selectedBP = { ...selectedBlocksP }
        let list = [...blocks];

        if (selectedBlocks.length > 1) {
            // console.log("====================================ddddddddd=================================")
            list.map(e => {
                selectedBlocks.map(item => {
                    if (e.blockId == item) {
                        e.positionX = Math.round(e.positionX - selectedBP.x);
                        e.positionY = Math.round(e.positionY - selectedBP.y);
                    }
                })
            });
            Api.editBlock(null, list);
            setBlocks(list);
            setSelectedBlocksP({ x: 0, y: 0 });
            findXYposition(list);

        } else if (!isDraggingbox && isGroupDraggingActive) {

            list.map(e => {
                e.positionX = Math.round(e.positionX - totalmoved.x);
                e.positionY = Math.round(e.positionY - totalmoved.y);

            });
            Api.editBlock(null, list);
            setBlocks(list);
            setGroupPosition({ x: 0, y: 0 })
            findXYposition(list);
        }
    }

    const IncressScrollSize = () => {
        let e = document.getElementById("hidden-div");
        const scrollX = e.scrollLeft;
        const scrollY = e.scrollTop;

        const maxScrollX = e.scrollWidth - e.clientWidth;
        const maxScrollY = e.scrollHeight - e.clientHeight;

        const scrollPercentX = (scrollX / maxScrollX) * 100;
        const scrollPercentY = (scrollY / maxScrollY) * 100;

        const childDiv = document.getElementById('zoom-container');
        const currentWidth = parseFloat(getComputedStyle(childDiv).width);
        const currentHeight = parseFloat(getComputedStyle(childDiv).height);

        if (scrollPercentX >= 85) {
            childDiv.style.width = (currentWidth + 1000) + 'px';
        }
        if (scrollPercentY >= 85) {
            childDiv.style.height = (currentHeight + 1000) + 'px';
        }
    }

    const focusOnDivItem = () => {
        const keepInCheck = document.getElementById('hidden-div');
        if (!isFirstFocus && keepInCheck) {

            setIsFirstFocus(true)
            const topLeft = { x: boxXYPosition.topLeft.x, y: boxXYPosition.topLeft.y };
            const bottomRight = { x: boxXYPosition.bottomRight.x, y: boxXYPosition.bottomRight.y };

            const groupCenterX = (topLeft.x) * scale;
            const groupCenterY = (topLeft.y) * scale;

            keepInCheck.scrollTo({
                top: groupCenterY,
                left: groupCenterX,
                behavior: 'smooth'
            });
        }
    }

    const handleBlockSelect = (blockId, event) => {
        event.stopPropagation();
        if (event.ctrlKey) {
            setSelectedBlocks((prev) => {
                if (prev.includes(blockId)) {
                    let a = prev.filter(id => id !== blockId);
                    findSelectedXYposition(a)
                    return a;
                } else {
                    findSelectedXYposition([...prev, blockId])
                    return [...prev, blockId];
                }
            });
        } else {
            setActiveRow(blockId);
        }
    };


    // ==================================================== selected group ===========================================

    const findSelectedXYposition = (selectedbox) => {
        const boxWidth = 75;
        const boxHeight = 100;

        let topLeftX = Infinity;
        let topLeftY = Infinity;
        let bottomRightX = -Infinity;
        let bottomRightY = -Infinity;

        blocks.forEach(box => {
            selectedbox.forEach(id => {
                if (id == box.blockId) {
                    const { positionX, positionY } = box;

                    // Calculate corners for each box
                    const boxRightX = positionX + boxWidth;
                    const boxBottomY = positionY + boxHeight;

                    // Update topLeftX and topLeftY
                    topLeftX = Math.min(topLeftX, positionX);
                    topLeftY = Math.min(topLeftY, positionY);

                    // Update bottomRightX and bottomRightY
                    bottomRightX = Math.max(bottomRightX, boxRightX);
                    bottomRightY = Math.max(bottomRightY, boxBottomY);
                }
            })

        });
        setSelectedBoxXYPosition({
            topLeft: { x: topLeftX, y: topLeftY },
            topRight: { x: bottomRightX, y: topLeftY },
            bottomLeft: { x: topLeftX, y: bottomRightY },
            bottomRight: { x: bottomRightX, y: bottomRightY }
        });
    }

    // const findClickIsBetweenPosition = (clientX, clientY) => {
    //     const topLeft = { x: boxXYPosition.topLeft.x, y: boxXYPosition.topLeft.y };
    //     const bottomRight = { x: boxXYPosition.bottomRight.x, y: boxXYPosition.bottomRight.y };
    //     const layer1 = document.getElementById('zoom-container');
    //     const layer1Rect = layer1.getBoundingClientRect();
    //     const relativeX = (clientX - layer1Rect.left) / scale;
    //     const relativeY = (clientY - layer1Rect.top) / scale;
    //     if (
    //         relativeX >= topLeft.x &&
    //         relativeX <= bottomRight.x &&
    //         relativeY >= topLeft.y &&
    //         relativeY <= bottomRight.y
    //     ) {
    //         if (!isGroupDraggingActive) {
    //             setInitialGroupPosition({ x: relativeX, y: relativeY });
    //             setIsGroupDraggingActive(true)
    //         }
    //     }
    // }

    // ==================================================== selected group ===========================================


    return (
        <>
            {projectId === "" || projectId === null
                ?
                <div className="container-fluid page-body-wrapper">
                    <div className="main-panel">
                        <div className="content-wrapper pt-4">
                            <div className="row purchace-popup">
                                <div className="col-12 stretch-card grid-margin">
                                    <div className="card card-secondary">
                                        <span className="card-body text-center">
                                            <span style={{ color: '#007bff', cursor: 'pointer' }} onClick={handleShowProjectModal}>Add New Project</span>
                                            <p className="mb-lg-0">Or</p>
                                            <p className="mb-lg-0">Select Project to continue.</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* add/update project modal */}
                    <CreateProjectModel show={showProjectModal} handleClose={handleCloseProjectModal} saveProjectData={saveProjectData} data={projectData} handleChanges={handleProjectChanges} handleShowDeleteModal={handleShowProjectDeleteModal} isButtonDisabled={isButtonDisabled}></CreateProjectModel>

                    {/* delete project modal */}
                    <DeleteModel show={showDeleteProjectModal} handleClose={handleCloseProjectDeleteModal} DeleteData={deleteProject}></DeleteModel>
                </div>
                :
                <div className="container-fluid page-body-wrapper">
                    <div className="main-panel">
                        <div className="content-wrapper pt-4">
                            <div className="row purchace-popup">
                                <div className="col-12 stretch-card grid-margin">
                                    <div className="card card-secondary">
                                        <span className="card-body d-lg-flex align-items-center py-2">
                                            {projectDetails && projectDetails.clientName || projectDetails.description ?
                                                <p className="mb-lg-0 clientDetails"> <b className='clientDetails'>{projectDetails.clientName && projectDetails.clientName} </b> {projectDetails.description && "- "}{projectDetails.description && projectDetails.description}</p>
                                                :
                                                <p className="mb-lg-0 clientDetails"> <b className='clientDetails'>{projectDetails && projectDetails.projectName && projectDetails.projectName} </b></p>
                                            }
                                            <button className="btn ml-lg-auto btn-success btn-sm block" onClick={() => { runPDAModel() }}>Run PDA Model</button>
                                            <AiFillSetting className='settingIcon' onClick={() => { setShowSettingsPopup(true); clearSettingsData(); }} />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex">
                                <div className="flex-grow-1">
                                    <div className="grid-margin stretch-card">
                                        <div className="card">
                                            <div className={`card-body ${blocks && blocks.length !== 0 ? 'pt-0' : ''}`} style={{ height: "108vh" }}>
                                                {blocks && blocks.length !== 0 &&
                                                    <div className='text-right'>
                                                        {visible ?
                                                            <BsArrowRightCircleFill className="arrowIconRight" onClick={() => setVisible(!visible)} aria-expanded={visible}
                                                                aria-controls="collapseWidthExample" />
                                                            :
                                                            <BsArrowLeftCircleFill className="arrowIconLeft" onClick={() => setVisible(!visible)} aria-expanded={visible}
                                                                aria-controls="collapseWidthExample" />
                                                        }
                                                    </div>
                                                }
                                                <div className="row d-sm-flex align-items-baseline mb-3  report-summary-header pb-4">
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <h5 className="font-weight-semibold mb-0">Critical Path Network Diagram</h5>
                                                        <button className="btn btn-danger btn-sm ml-3" onClick={defaultPosition}>Set Default Position</button>
                                                    </div>


                                                    <div className="col-md-6 text-right">
                                                        <button title="Zoom In" className="w3-tiny w3-button w3-white w3-border" onClick={handleZoomIn}>+</button>
                                                        <button title="Zoom Out" className="w3-tiny w3-button w3-white w3-border" onClick={handleZoomOut}>-</button>
                                                        <button className="btn ml-2 btn-success btn-sm block" disabled={activeRow === "" ? false : true} onClick={() => { checkCategories(); setShowBlockPopup(true); clearBlockData(); }}>Add Block</button>
                                                        <button className="btn ml-2 btn-success btn-sm block" disabled={activeRow && activeRow !== "" ? false : true} onClick={() => { setShowBlockPopup(true); getBlockDetails(activeRow) }}>Edit Block</button>
                                                        <button className="btn ml-2 btn-danger btn-sm block" disabled={activeRow && activeRow !== "" ? false : true} onClick={() => { handleShow() }}>Delete Block</button>
                                                    </div>
                                                </div>
                                                {blocks && blocks.length === 0 ?
                                                    <div className='text-center'>Create Network Diagram and Run PDA Model to view the Report.</div>
                                                    :
                                                    // this one is layer-0
                                                    <div
                                                        className='layer-0'
                                                        id="hidden-div"
                                                        onMouseUpCapture={() => {
                                                            IncressScrollSize();
                                                        }}
                                                        onMouseOutCapture={(e) => {
                                                            IncressScrollSize();
                                                        }}
                                                    >
                                                        {/* this one is layer-1 */}
                                                        <div
                                                            id="zoom-container"
                                                            className="layer-1"
                                                            style={{
                                                                transform: `scale(${scale})`,
                                                                width: `${layer1Size.width}px`,
                                                                height: `${layer1Size.height}px`,
                                                                cursor: `${isMouseBetweenPosition && !isDragging ? "grab"
                                                                    : isMouseBetweenPosition && isDragging ? "grabbing"
                                                                        : "default"
                                                                    }`
                                                            }}
                                                            onMouseDown={(e) => {
                                                                if (!isDraggingbox) {
                                                                    findClickIsBetweenPosition(e.clientX, e.clientY, e.ctrlKey)
                                                                    setIsDragging(true);
                                                                    setInitialMousePosition({ x: e.clientX, y: e.clientY })
                                                                }

                                                                if (!e.ctrlKey) {
                                                                    setSelectedBlocks([]);
                                                                    setSelectedBlocksP({ x: 0, y: 0 });
                                                                }

                                                            }}

                                                            onMouseUpCapture={(e) => {
                                                                setIsDragging(false);
                                                                handleGroupStopPosition();
                                                                setIsGroupDraggingActive(false);
                                                            }}

                                                            onMouseLeave={() => {
                                                                console.log("on mouse leave")
                                                                handleGroupStopPosition()
                                                                setIsDragging(false);
                                                                setIsGroupDraggingActive(false);
                                                            }}

                                                            onMouseOut={() => {

                                                            }}

                                                            onMouseMove={(e) => {
                                                                e.stopPropagation();
                                                                checkCurserEnteredBetweenPosition(e.clientX, e.clientY)
                                                                if (isDragging && !isDraggingbox && !e.ctrlKey) {
                                                                    // alert("hello")
                                                                    let a = trakeMouseMoment(e);
                                                                    let old = { ...groupPosition }
                                                                    if (isGroupDraggingActive) {
                                                                        let b = { ...initialGroupPosition }
                                                                        let totalmovedX = b.x - a.x;
                                                                        let totalmovedY = b.y - a.y;

                                                                        const topLeft = { x: boxXYPosition.topLeft.x, y: boxXYPosition.topLeft.y };

                                                                        if ((topLeft.x - totalmovedX) >= 0) {
                                                                            old.x = totalmovedX
                                                                        }

                                                                        if ((topLeft.y - totalmovedY) >= 0) {
                                                                            old.y = totalmovedY
                                                                        }

                                                                        setGroupPosition(old);

                                                                    }
                                                                } else if (selectedBlocks.length > 1 && e.ctrlKey) {
                                                                    // selectedBlocksP, setSelectedBlocksP
                                                                    let a = trakeMouseMoment(e);
                                                                    let old = { ...selectedBlocksP }
                                                                    if (isGroupDraggingActive) {
                                                                        let b = { ...initialSelectedGroupPosition }
                                                                        let totalmovedX = b.x - a.x;
                                                                        let totalmovedY = b.y - a.y;

                                                                        const topLeft = { x: SelectedboxXYPosition.topLeft.x, y: SelectedboxXYPosition.topLeft.y };

                                                                        if ((topLeft.x - totalmovedX) >= 0) {
                                                                            old.x = totalmovedX
                                                                        }

                                                                        if ((topLeft.y - totalmovedY) >= 0) {
                                                                            old.y = totalmovedY
                                                                        }

                                                                        setSelectedBlocksP(old);

                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <Xwrapper>
                                                                {
                                                                    blocks && blocks.map((items) =>
                                                                        <Draggable
                                                                            handle=".handle"
                                                                            onMouseDown={(e) => {
                                                                                e.stopPropagation();
                                                                                if (!e.ctrlKey)
                                                                                    setIsGroupDraggingActive(false)
                                                                            }}
                                                                            onDrag={(e, data) => {
                                                                                if (!e.ctrlKey && !isGroupDraggingActive) {
                                                                                    setBlocks((prevBlocks) =>
                                                                                        prevBlocks.map((block) => {
                                                                                            if (block.blockId === items.blockId) {
                                                                                                return {
                                                                                                    ...block,
                                                                                                    positionX: block.positionX + data.deltaX,
                                                                                                    positionY: block.positionY + data.deltaY,
                                                                                                };
                                                                                            }
                                                                                            return block;
                                                                                        })
                                                                                    );
                                                                                }
                                                                            }}
                                                                            onStop={(dragElement, ui) => {
                                                                                handleOnStopPosition(dragElement, ui, items)
                                                                            }}
                                                                            position={
                                                                                selectedBlocks.length > 1 ?
                                                                                    selectedBlocks.includes(items.blockId) ?
                                                                                        { x: items.positionX - selectedBlocksP.x, y: items.positionY - selectedBlocksP.y } :
                                                                                        { x: items.positionX, y: items.positionY } :
                                                                                    { x: items.positionX - groupPosition.x, y: items.positionY - groupPosition.y }
                                                                            }
                                                                            key={`drag-${items.blockId}`}
                                                                            scale={scale}
                                                                            bounds={{ left: 0, top: 0 }}
                                                                        >
                                                                            <div
                                                                                id={"block_" + items.blockId}
                                                                                className={{
                                                                                    'handle': true,
                                                                                    'active': activeRow === items.blockId,
                                                                                    'text-light': checkDarkness(items.blockColor),
                                                                                    'selected': selectedBlocks.includes(items.blockId)
                                                                                }}
                                                                                style={{
                                                                                    ...blockStyle,
                                                                                    background: items.blockColor,
                                                                                    border: (selectedBlocks.includes(items.blockId) || activeRow === items.blockId) ? "2px solid #0056b3" : "none"
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    if (e.ctrlKey) {
                                                                                        handleBlockSelect(items.blockId, e)
                                                                                    } else {
                                                                                        setSelectedBlocks([]);
                                                                                        clickBlock(e, "block_" + items.blockId, items.blockId);
                                                                                    }
                                                                                }}
                                                                                onMouseEnter={(e) => {
                                                                                    if (!e.ctrlKey) {
                                                                                        setIsDraggingbox(true);
                                                                                        setIsGroupDraggingActive(false);
                                                                                        handleHoverElementMouseEnter();
                                                                                    }
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    if (!e.ctrlKey)
                                                                                        handleHoverElementMouseLeave(e)
                                                                                }}
                                                                                onMouseDown={(e) => {
                                                                                    if (!e.ctrlKey)
                                                                                        setIsDraggingbox(true)
                                                                                }}
                                                                                onMouseUpCapture={(e) => { if (!e.ctrlKey) setIsDraggingbox(false) }}
                                                                                onMouseOutCapture={(e) => { if (!e.ctrlKey) setIsDraggingbox(false) }}
                                                                            >
                                                                                <div className='row' style={{ borderBottom: "1px solid #ccc", marginRight: "-5px", marginLeft: "-5px" }}>
                                                                                    <div>
                                                                                        <p className='card-header-flex'>
                                                                                            <b>{items.CategoryName}</b>
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <p className='card-subHeader-flex'>
                                                                                    <b>{items.blockNumber + "."} </b>
                                                                                    {items.blockName}
                                                                                </p>
                                                                                <div className='card-body-flex'>
                                                                                    <div className='card-item-flex smallBlock'>
                                                                                        <p className='card-item-child1-flex'>DET</p>
                                                                                        <p className='card-item-child2-flex'>{items.duration}</p>
                                                                                    </div>
                                                                                    <div className='card-item-flex smallBlock'>
                                                                                        <p className='card-item-child1-flex'>P10</p>
                                                                                        <p className='card-item-child2-flex'>{items.p10}</p>
                                                                                    </div>
                                                                                    <div className='card-item-flex smallBlock'>
                                                                                        <p className='card-item-child1-flex'>P90</p>
                                                                                        <p className='card-item-child2-flex'>{items.p90}</p>
                                                                                    </div>
                                                                                </div>

                                                                                <div className='card-body-flex'>
                                                                                    {items.a && items.a !== 0 ?
                                                                                        <div className='card-item-flex smallBlock'>
                                                                                            <p className='card-item-child1-flex'>Alpha</p>
                                                                                            <p className='card-item-child2-flex'>{items.a}</p>
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                    }

                                                                                    {items.b && items.b !== 0 ?
                                                                                        <div className='card-item-flex smallBlock'>
                                                                                            <p className='card-item-child1-flex'>Beta</p>
                                                                                            <p className='card-item-child2-flex'>{items.b}</p>
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                </div>

                                                                                <div className='card-item-flex'>
                                                                                    {items.lowerBound && items.lowerBound !== 0 ?
                                                                                        <p className='card-footer-flex'>Lower Bound : {items.lowerBound}</p>
                                                                                        :
                                                                                        null}
                                                                                    {items.upperBound && items.upperBound !== 0 ?
                                                                                        <p className='card-footer-flex'>Upper Bound : {items.upperBound}</p>
                                                                                        :
                                                                                        null}
                                                                                </div>
                                                                            </div>
                                                                        </Draggable>
                                                                    )
                                                                }

                                                                {
                                                                    connections && connections.length ? connections.map((items) =>
                                                                        <Xarrow
                                                                            path="grid"
                                                                            start={`block_` + items.start}
                                                                            end={`block_` + items.end}
                                                                            strokeWidth={arrowSizing.strokeWidth}
                                                                            headSize={arrowSizing.headSize}
                                                                            divContainerStyle={{ transform: `scale(${arrowSizing.scale})` }}
                                                                            labels={
                                                                                <i style={{ cursor: "pointer" }}
                                                                                    onClick={() => deleteConnection(items.id)}
                                                                                >
                                                                                    <AiOutlineClose />
                                                                                </i>
                                                                            }>
                                                                        </Xarrow>
                                                                    ) : ''
                                                                }
                                                            </Xwrapper>
                                                            {
                                                                focusOnDivItem()
                                                            }
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='blocksTable'>
                                    {blocks && blocks.length !== 0 &&
                                        <CCollapse id="collapseWidthExample" horizontal visible={visible}>
                                            <div className='table-data table-data-custom'>
                                                <Table bordered style={{ marginLeft: '20px', width: '190px' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Blocks</th>
                                                            <th>Predecessors</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {blocks && blocks.map(item =>
                                                            <tr className={activeRow && activeRow == item.blockId ? 'active' : ""}>
                                                                <td>{item.blockNumber}</td>
                                                                <td>{item.predecessors && item.predecessors.join(",")}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </CCollapse>
                                    }
                                </div>
                            </div>
                        </div>
                        {/* save settings popup */}
                        <Modal
                            show={showSettingsPopup}
                            onHide={() => setShowSettingsPopup(false)}
                            // added two lines by chanchal
                            backdrop='static'
                            keyboard={false}
                        >
                            <Form onSubmit={saveSettings} noValidate>
                                <Modal.Header closeButton>
                                    <Modal.Title >Enter Settings Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Number Of Runs</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={1}
                                                        name="numberOfRuns"
                                                        placeholder="Enter Number Of Runs"
                                                        value={settingsData.numberOfRuns}
                                                        onChange={(e) => handleSettingsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Alpha</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={1}
                                                        name="alpha"
                                                        placeholder="Enter alpha"
                                                        value={settingsData.alpha}
                                                        onChange={(e) => handleSettingsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Beta</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={1}
                                                        name="beta"
                                                        placeholder="Enter Beta"
                                                        value={settingsData.beta}
                                                        onChange={(e) => handleSettingsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Lower Bound Multiplier</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={1}
                                                        step=".01"
                                                        name="lowerBoundMultiplier"
                                                        placeholder="Enter Lower Bound Multiplier"
                                                        value={settingsData.lowerBoundMultiplier}
                                                        onChange={(e) => handleSettingsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Upper Bound Multiplier</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={1}
                                                        step=".01"
                                                        name="upperBoundMultiplier"
                                                        placeholder="Upper Lower Bound Multiplier"
                                                        value={settingsData.upperBoundMultiplier}
                                                        onChange={(e) => handleSettingsChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </Col>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit" variant="success btn-sm">Save</Button>
                                    <Button variant="danger btn-sm" onClick={() => { setShowSettingsPopup(false); clearSettingsData(); }}>
                                        Cancel
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                        {/* add/edit block popup */}
                        <Modal
                            show={showBlockPopup}
                            onHide={() => { setShowBlockPopup(false); clearBlockData(); }}
                            backdrop='static'
                            keyboard={false}
                        >
                            <Form onSubmit={addBlock} noValidate validated={validated}>
                                <Modal.Header closeButton>
                                    <Modal.Title >Enter Block Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col className="mb-3">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Block #</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="number"
                                                        min={0}
                                                        step="0.1"
                                                        name="blockNumber"
                                                        placeholder="Enter Block Number"
                                                        // value={blockData.blockNumber || ""}
                                                        value={blockData.blockNumber !== undefined ? blockData.blockNumber : blockNumber}
                                                        onChange={handleBlockChange}
                                                        isInvalid={!!blockNumberError}
                                                        isValid={blockData.blockNumber && !blockNumberError}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {blockNumberError || "Number is Required!"}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Label>Block Color</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="blockColor"
                                                    placeholder="Select Color"
                                                    // changes by chanchal
                                                    value={blockData.blockColor || blockColor || '#dfe5eb'}
                                                    onChange={(e) => handleBlockChange(e)}
                                                />
                                            </Col>
                                            <Col>
                                                <Form.Label></Form.Label>
                                                <Form.Control
                                                    type="color"
                                                    name="blockColor"
                                                    // changes by chanchal
                                                    value={blockData.blockColor || blockColor || "#dfe5eb"}
                                                    onChange={(e) => handleBlockChange(e)}
                                                />
                                            </Col>
                                            <Col>
                                                <Form.Label>Recently used</Form.Label>
                                                <div style={{ display: 'flex', gap: '5px', marginTop: '4px' }}>
                                                    {recentFourColors.map((color, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                backgroundColor: color,
                                                                cursor: 'pointer',
                                                                border: blockColor === color ? '2px solid black' : 'none'
                                                            }}
                                                            // changes by chanchal
                                                            onClick={() => {
                                                                setBlockColor(color);
                                                                handleBlockChange({ target: { name: 'blockColor', value: color } });
                                                            }}
                                                        ></div>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Name</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="blockName"
                                                        placeholder="Enter Block Name"
                                                        value={blockData.blockName}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Name is Required!
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Select Category</Form.Label>
                                                    <Form.Select
                                                        required
                                                        aria-label="Default select example"
                                                        name="categoryId"
                                                        id="categoryId"
                                                        value={blockData.categoryId}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    >
                                                        <option value=''>select category</option>
                                                        {categoriesList && categoriesList.map(items => (
                                                            <option value={items.categoryId}>{items.category1}</option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Category is Required!
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Duration</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="number"
                                                        min="0"
                                                        step=".01"
                                                        name="duration"
                                                        placeholder="Enter Duration"
                                                        value={blockData.duration}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Duration is Required!
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>P10</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="number"
                                                        min="0"
                                                        step=".01"
                                                        name="p10"
                                                        placeholder="Enter p10"
                                                        value={blockData.p10}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        P10 is Required!
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>P90</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="number"
                                                        min="0"
                                                        step=".01"
                                                        name="p90"
                                                        placeholder="Enter p90"
                                                        value={blockData.p90}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        P90 is Required!
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Alpha (Optional)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="99.99"
                                                        step=".01"
                                                        name="a"
                                                        placeholder="Enter Alpha"
                                                        value={blockData.a}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Beta (Optional)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="99.99"
                                                        step=".01"
                                                        name="b"
                                                        placeholder="Enter Beta"
                                                        value={blockData.b}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Lower Bound (Optional)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="99.99"
                                                        step=".01"
                                                        name="lowerBound"
                                                        placeholder="Enter Lower Bound"
                                                        value={blockData.lowerBound}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Upper Bound (Optional)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="99.99"
                                                        step=".01"
                                                        name="upperBound"
                                                        placeholder="Enter Upper Bound"
                                                        value={blockData.upperBound}
                                                        onChange={(e) => handleBlockChange(e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit" variant="success btn-sm" disabled={isButtonDisabled}>
                                        {blockData && blockData.blockId && blockData.blockId !== "" ? "Update" : "Add"}
                                    </Button>
                                    <Button variant="danger btn-sm" onClick={() => { setShowBlockPopup(false); clearBlockData(); }}>
                                        Cancel
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                        {/* generating report popup */}
                        <Modal
                            show={showReportPopup}
                            onHide={() => setShowReportPopup(false)}
                            // added two lines by chanchal
                            backdrop='static'
                            keyboard={false}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title >{runPDAMsg}</Modal.Title>
                            </Modal.Header>
                        </Modal>

                        {/* delete popup */}
                        <DeleteModel show={showDeletePopup} handleClose={handleClose} DeleteData={deleteBlock}></DeleteModel>
                    </div>
                </div>
            }
        </>
    );
};

export default PDAModel;